import { AppStore } from "../stores/app.store";
import { useAppStore } from "./app.store.consumer";
import * as React from "react";
import { History } from "history";
import heroImage from "../assets/img/report_pic.png";

interface TopHeaderProps {
	//title: string;
	//bgImage: ImageBitmap;
	appStore?: AppStore;
	history?: History<any>;
}

@useAppStore()
export class TopHeader extends React.Component<TopHeaderProps> {
	private userStore = this.props.appStore.userStore;
	render() {
		return (
			<div className="cih-hide-print">
				{this.userStore.isLoggedIn && <div className="cih-message-stripe"><span>Welcome {this.userStore.firstName}!</span></div>}
				<div className="cih-hero-img" style={{ backgroundImage: `url(${heroImage})` }}>
					<div>My professional profile</div>
					{/*<img src={heroImage} alt="Report Illustration" /> */}
				</div>
			</div>
		);
	}
}
